import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=5d3d3276&scoped=true&"
import script from "./FavoriteButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d3276",
  null
  
)

export default component.exports